import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { api } from '@shared/api/api.contract';
import { Skill, InsertSkill } from '../dto';

@Injectable({
  providedIn: 'root',
})
export class SkillsService {
  /** React Query invalidateQueries karşılığı */
  private refresh$ = new Subject<void>();

  constructor(private http: HttpClient) {}

  /** GET /skills */
  getSkills(): Observable<Skill[]> {
    return this.http
      .get<Skill[]>(api.skills.list.path, {
        withCredentials: true,
      })
      .pipe(
        catchError(() =>
          throwError(() => new Error('Failed to fetch skills'))
        )
      );
  }

  /** POST /skills */
  createSkill(data: InsertSkill): Observable<Skill> {
    const validated = api.skills.create.input.parse(data);

    return this.http
      .post<Skill>(api.skills.create.path, validated, {
        withCredentials: true,
      })
      .pipe(
        tap(() => this.refresh$.next()),
        catchError((err) => {
          if (err.status === 400) {
            throw new Error(err.error?.message ?? 'Validation error');
          }
          throw new Error('Failed to create skill');
        })
      );
  }

  /** invalidateQueries eşdeğeri */
  onRefresh(): Observable<void> {
    return this.refresh$.asObservable();
  }
}
